import { render, staticRenderFns } from "./SellOfferDetails.vue?vue&type=template&id=2a7ec641&scoped=true"
import script from "./SellOfferDetails.vue?vue&type=script&lang=ts"
export * from "./SellOfferDetails.vue?vue&type=script&lang=ts"
import style0 from "./SellOfferDetails.vue?vue&type=style&index=0&id=2a7ec641&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7ec641",
  null
  
)

export default component.exports